module.exports = __webpack_public_path__ + "static/img/tianfangyuan.14d9be1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/tianfangyuan.jpg
// module id = ow8T
// module chunks = 52